import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Dimmer, Form, Icon, Loader, Table } from 'semantic-ui-react';
import store from '../../../store';
import { formatDate, formatDateTime } from '../../../utils/shared.utils';
import './warehouse.admin.scss';

function formatImportExpireDisplay(raw: string | null | undefined): string {
    if (raw == null || String(raw).trim() === '') return '—';
    const s = String(raw).trim();
    const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    const d = ymd
        ? new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]))
        : new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString('mn-MN', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function AdminWarehouseImportsPageComponent(props: any) {
    const history = useHistory();
    const id = props.match.params.id;

    const [warehouse, setWarehouse] = useState<{ id: number; productName: string; slug: string } | null>(null);
    const [importsList, setImportsList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const today = new Date();
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 30);
    const [startDate, setStartDate] = useState(formatDate(pastDate));
    const [endDate, setEndDate] = useState(formatDate(today));

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token || token === 'undefined') {
            store.dispatch({ type: 'redirectUrl', data: window.location.pathname });
            history.push('/');
            return;
        }
        fetchImports();
    }, [id, history]);

    const fetchImports = () => {
        const token = localStorage.getItem('adminToken');
        if (!token) return;
        setLoading(true);
        fetch(process.env.REACT_APP_API_URL + 'mongol/warehouse/' + id + '/imports', {
            method: 'POST',
            headers: { Accept: 'application/json', Authorization: token, 'Content-Type': 'application/json' },
            body: JSON.stringify({ startDate: startDate + ' 00:00:00', endDate: endDate + ' 23:59:59' }),
        })
            .then((r) => (r.ok ? r.json() : Promise.reject()))
            .then((data) => {
                if (data?.warehouse) setWarehouse(data.warehouse);
                setImportsList(Array.isArray(data?.imports) ? data.imports : []);
            })
            .catch(() => setWarehouse(null))
            .finally(() => setLoading(false));
    };

    if (!loading && !warehouse) {
        return (
            <div className="page-admin">
                <p>Агуулах олдсонгүй.</p>
            </div>
        );
    }

    return (
        <div className="page-admin">
            <section className="admin-warehouse-form warehouse-imports-page">
                <Dimmer active={loading}>
                    <Loader size="medium" />
                </Dimmer>
                <a onClick={() => history.goBack()}>
                    <Icon name="angle left" />
                    <span className="underline">Буцах</span>
                </a>
                <div className="width-100 text-center">
                    <h1>Өртгийн жагсаалт</h1>
                </div>
                <div className="width-100">
                    <h2>{warehouse?.productName}</h2>
                </div>
                {warehouse?.slug ? (
                    <a className="underline" href={'/product/' + warehouse.slug} target="_blank" rel="noopener noreferrer">
                        Худалдааны линк
                    </a>
                ) : null}
                <br />
                <br />
                <div className="warehouse-actions">

                    <div className="report-filter">
                        <Form.Input label="Эхний өдөр: " type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                        &nbsp;&nbsp;&nbsp;
                        <Form.Input label="Сүүлийн өдөр: " type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                        &nbsp;&nbsp;&nbsp;
                        <Button onClick={() => fetchImports()}>Дата татах</Button>
                        <br />
                        <br />
                    </div>
                </div>

                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>#</Table.HeaderCell>
                            <Table.HeaderCell>Өртөг</Table.HeaderCell>
                            <Table.HeaderCell>Эхний үлдэгдэл</Table.HeaderCell>
                            <Table.HeaderCell>Одоогийн үлдэгдэл</Table.HeaderCell>
                            <Table.HeaderCell>Огноо</Table.HeaderCell>
                            <Table.HeaderCell>Дуусах огноо</Table.HeaderCell>
                            <Table.HeaderCell>Нэмсэн хэрэглэгч</Table.HeaderCell>
                            <Table.HeaderCell>Тайлбар</Table.HeaderCell>
                            <Table.HeaderCell width="1">Дэлгэрэнгүй</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {importsList.map((imp: any, index: number) => (
                            <Table.Row key={'import-' + imp.id}>
                                <Table.Cell data-label="#">{index + 1}</Table.Cell>
                                <Table.Cell data-label="Өртөг">
                                    {imp.cost != null
                                        ? parseFloat(imp.cost).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }) + ' ₮'
                                        : '–'}
                                </Table.Cell>
                                <Table.Cell data-label="Эхний үлдэгдэл">{imp.originalCount != null ? imp.originalCount : '–'}</Table.Cell>
                                <Table.Cell data-label="Одоогийн үлдэгдэл">{imp.count != null ? imp.count : '–'}</Table.Cell>
                                <Table.Cell data-label="Огноо">{imp.createdAt ? formatDateTime(new Date(imp.createdAt)) : '–'}</Table.Cell>
                                <Table.Cell data-label="Дуусах огноо">{formatImportExpireDisplay(imp.expireDate)}</Table.Cell>
                                <Table.Cell data-label="Нэмсэн хэрэглэгч">{imp.createdBy || '–'}</Table.Cell>
                                <Table.Cell data-label="Тайлбар">{imp.note || '–'}</Table.Cell>
                                <Table.Cell className="cursor" data-label="Дэлгэрэнгүй">
                                    <Link to={'/mongol/warehouse/' + id + '/import/' + imp.id + '/history'}>
                                        <strong><Icon name="folder open outline" /></strong>
                                    </Link>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
                {importsList.length === 0 && <p className="margin-top-20">Өртөг бүртгэл олдсонгүй.</p>}
            </section>
        </div>
    );
}
